/*
  +--------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     用户注册 API接口
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function usernameCheckApi(data) {
  return request({
    url: '?c=login&a=register&do=username-check',
    method: 'post',
    data: data
  })
}

export function mobileCheckApi(data) {
  return request({
    url: '?c=login&a=register&do=mobile-check',
    method: 'post',
    data: data
  })
}

export function codeSendApi(data) {
  return request({
    url: '?c=login&a=register&do=code-send',
    method: 'post',
    data: data
  })
}

export function registerApi(data) {
  return request({
    url: '?c=login&a=register&do=post',
    method: 'post',
    data: data
  })
}

export function resetApi(data) {
  return request({
    url: '?c=login&a=reset',
    method: 'post',
    data: data
  })
}
